import React from 'react';
import {
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import MainLayout from './components/MainLayout/MainLayout';
import SubLayout from './components/SubLayout/SubLayout';
import LoginLayout from './components/LoginLayout/LoginLayout';
import OverviewUploadedList from './components/Overview/OverviewUploadedList';
import OverviewfileDetail from './components/Overview/OverviewfileDetail';
import OverviewProjectList from './components/Overview/OverviewProjectList';
import OverviewIssueList from './components/Overview/OverviewIssueList';
import ComponentList from './components/Component/ComponentList';
import ComponentProjectList from './components/Component/ComponentProjectList';
import SecurityRiskList from './components/Security/SecurityRiskList';
import CNVDList from './components/Security/CNVDList';
import SecurityProjectList from './components/Security/SecurityProjectList';
import LicenseList from './components/License/LicenseList';
import LitigatorList from './components/License/LitigatorList';
import LicenseProjectList from './components/License/LicenseProjectList';
import PolicyList from './components/Policy/PolicyList';
import PolicyRevisionList from './components/Policy/PolicyRevisionList';
import PolicyProjectList from './components/Policy/PolicyProjectList';
import PolicyDetail from './components/Policy/PolicyDetail';
import Dashboard from './components/Dashboard/Dashboard';
import KnowledgeBaseLayout from './components/KnowledgeBase/KnowledgeBaseLayout';
import SearchCveCode from './components/KnowledgeBase/SearchCveCode';
import SearchCveDetail from './components/KnowledgeBase/SearchCveDetail';
import Login from './components/Login/Login';
import ConfirmAccount from './components/ConfirmAccount/ConfirmAccount';
import UserProfile from './components/UserProfile/UserProfile';
import ComponentDetail from './components/Component/ComponentDetail';
import SecurityDetail from './components/Security/SecurityDetail';
import LicenseDetail from './components/License/LicenseDetail';
import LitigatorDetail from './components/License/LitigatorDetail';

import MyPage from './components/MyPage/MyPage';
import MyIssue from './components/MyPage/MyIssue';
import MyBookmark from './components/MyPage/MyBookmark';
import MyScanOptions from './components/MyPage/MyScanOptions';
import MyExportView from './components/MyPage/MyExportView';
import MyConnections from './components/MyPage/MyConnections';
import MyNotifications from './components/MyPage/MyNotifications';

import About from './components/About/About';

import PolicySetting from './components/NewSettings/PolicySetting';
import IssueSetting from './components/NewSettings/IssueSetting';
import ProjectSetting from './components/NewSettings/ProjectSetting';
import UserSetting from './components/NewSettings/UserSetting';
import GroupSetting from './components/NewSettings/GroupSetting';
import LDAPGroupSetting from './components/NewSettings/LDAPGroupSetting';
import NewSettings from './components/NewSettings/Settings';
import DefinedResultsSetting from './components/NewSettings/DefinedResultsSetting';
import PrecisionSetting from './components/NewSettings/PrecisionSetting';
import LeakageSetting from './components/NewSettings/LeakageSetting';
import ContinuousScanSetting from './components/NewSettings/ContinuousScanSetting';
import CryptographySetting from './components/NewSettings/CryptographySetting';

import SystemSetting from './components/Systems/SystemSettings';
import LicenseSystem from './components/Systems/LicenseSystem';
import LoadBalancerSystem from './components/Systems/LoadBalancerSystem';
//import DBSystem from './components/Systems/DBSystem';
import LDAPSystem from './components/Systems/LDAPSystem';
import SMTPSystem from './components/Systems/SMTPSystem';
import CloudIntegration from './components/Systems/CloudIntegration';
import UpdateSystem from './components/Systems/UpdateSystem';
import TimeZoneSystem from './components/Systems/TimeZoneSystem';
import LanguageSystem from './components/Systems/LanguageSystem';
import WebSecuritySystem from './components/Systems/WebSecuritySystem';
import System from './components/Systems/System';
import NoMatch from './components/NoMatch/NoMatch';
import FingerPrinting from './components/Extensions/FingerPrinting';
import ReleaseNotes from './components/ReleaseNotes/ReleaseNotes';

/**
   * Routes are defined here. They are loaded asynchronously.
   * Paths are relative to the "components" directory.
   * @param {Object}
   * @returns {Object}
   */
function CreateRoutes({ state }) {
  return (
    <Routes>
      <Route element={<FingerPrinting><LoginLayout /></FingerPrinting>}>
        <Route index element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/logout"
          element={<Login />}
        />
        <Route path="/confirm_account" element={<ConfirmAccount />} title="Confirm Account" />
        <Route path="/reset_password" element={<ConfirmAccount />} title="Reset Password" />
      </Route>
      <Route
        element={<MainLayout state={state} />}
      >
        <Route index element={<SubLayout />} />
        <Route path="/main" element={<Dashboard />} title="dashboard" />
        <Route path="/knowledge_base" element={<KnowledgeBaseLayout />} title="knowledge_base">
          <Route index element={<Navigate to="component" replace />} />
          <Route path="component" element={<SearchCveCode />} />
          <Route path="cve" element={<SearchCveDetail />} />
        </Route>

        <Route path="/results" element={<SubLayout />}>
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview">
            <Route index element={<OverviewUploadedList />} />
            <Route path="binary" element={<OverviewUploadedList />} title="Binary" />
            <Route path="binary/:idReport" element={<OverviewfileDetail />} title="result" />
            <Route path="project" element={<OverviewProjectList />} title="Project" />
            <Route path="issue" element={<OverviewIssueList />} title="Issue" />
          </Route>
          <Route path="component">
            <Route index element={<ComponentList />} />
            <Route path="binary" element={<ComponentList />} title="Binary" />
            <Route path="binary/:idReport" element={<ComponentDetail />} title="result" />
            <Route path="project" element={<ComponentProjectList />} title="Project" />
          </Route>
          <Route path="security">
            <Route index element={<SecurityRiskList />} />
            <Route path="binary" element={<SecurityRiskList />} title="Binary" />
            <Route path="binary/:idReport" element={<SecurityDetail />} title="result" />
            <Route path="cnvd/:idReport" element={<CNVDList />} title="cnvd" />
            <Route path="project" element={<SecurityProjectList />} title="Project" />
          </Route>
          <Route path="license">
            <Route index element={<LicenseList />} />
            <Route path="binary" element={<LicenseList />} title="Binary" />
            <Route path="binary/:idReport" element={<LicenseDetail />} title="License result" />
            <Route path="litigator" element={<LitigatorList />} title="litigator" />
            <Route
              path="litigator/:idReport"
              element={<LitigatorDetail />}
              title="Litigator result"
            />
            <Route path="project" element={<LicenseProjectList />} title="Project" />
          </Route>
          <Route path="policy">
            <Route index element={<PolicyList />} />
            <Route path="binary" element={<PolicyList />} title="Binary" />
            <Route path="binary/:idReport" element={<PolicyRevisionList />} title="Policy Revision" />
            <Route path="project" element={<PolicyProjectList />} title="Project" />
            <Route path="project/:idReport" element={<PolicyDetail />} title="result" />
          </Route>
        </Route>
        <Route path="/my_page" element={<MyPage />}>
          <Route index element={<Navigate to="bookmark" replace />} />
          <Route path="issue" element={<MyIssue />} />
          <Route path="bookmark" element={<MyBookmark />} />
          <Route path="scan_options" element={<MyScanOptions />} />
          <Route path="export_options" element={<MyExportView />} />
          <Route path="connections" element={<MyConnections />} />
          <Route path="notifications" element={<MyNotifications />} />
        </Route>

        <Route path="/settings" element={<NewSettings />} title="Settings">
          <Route index element={<Navigate to="project" replace />} />
          <Route path="policy" element={<PolicySetting />} />
          <Route path="precision" element={<PrecisionSetting />} />
          <Route path="issue" element={<IssueSetting />} />
          <Route path="project" element={<ProjectSetting />} />
          <Route path="defined" element={<DefinedResultsSetting />} />
          <Route path="crypto" element={<CryptographySetting />} />
          <Route path="leakage" element={<LeakageSetting />} />
          <Route path="continuous_scan" element={<ContinuousScanSetting />} />
          <Route path="user" element={<UserSetting />} />
          <Route path="groups">
            <Route index element={<Navigate to="local" replace />} />
            <Route path="local" element={<GroupSetting />} title="Local" />
            <Route path="ldap" element={<LDAPGroupSetting />} title="LDAP" />
          </Route>
        </Route>

        <Route path="/profile" element={<UserProfile />} title="Profile" />
        <Route path="/systems" element={<SystemSetting />} title="System Settings">
          <Route index element={<Navigate to="license" replace />} />
          <Route path="web_server" element={<LoadBalancerSystem />} />
          <Route path="ldap" element={<LDAPSystem />} />
          <Route path="smtp" element={<SMTPSystem />} />
          <Route path="aws" element={<CloudIntegration />} />
          {/*<Route path="/customdb" element={<DBSystem />} />*/}
          <Route path="license" element={<LicenseSystem />} />
          <Route path="system" element={<System />} />
          <Route path="security" element={<WebSecuritySystem />} />
          <Route path="timezone" element={<TimeZoneSystem />} />
          <Route path="language" element={<LanguageSystem />} />
          <Route path="update" element={<UpdateSystem />} />
        </Route>
        <Route path="/about" element={<About />} title="About Clarity" />
        <Route path="release-notes" element={<ReleaseNotes />} title="Release Notes" />
      </Route>
      <Route path="*" element={<NoMatch />} />
    </Routes>
  );
}

export default CreateRoutes;
